import * as React from "react";
import { ExtraPageInfo, ExtraPageResource } from "burde";
import { connect } from "react-redux";
import { actionCreators } from "page/calendar/store";
import * as styles from "./extra-page-selector.css";
import { useResources } from "contexts/resource-context";
import Button from "content/button/button";

type Props = {
    extraPageResources: ExtraPageResource[] | undefined;
    addedExtraPages: number[];
    onUpdatePreviewedExtraPage: (id: number) => void;
    onUpdateExtraPages: (extraPages: number[]) => void;
    numberOfPagesLeft: number;
    selectedResourceGroup: ExtraPageResource | null;
    setSelectedResourceGroup: React.Dispatch<
        React.SetStateAction<ExtraPageResource | null>
    >;
} & typeof actionCreators;

const ExtraPageSelector = ({
    extraPageResources,
    onUpdatePreviewedExtraPage,
    addedExtraPages,
    onUpdateExtraPages,
    numberOfPagesLeft,
    selectedResourceGroup,
    setSelectedResourceGroup,
}: Props) => {
    const resources = useResources();

    return (
        <div>
            <ul className={styles.tabGroup}>
                {extraPageResources !== undefined &&
                    extraPageResources.length > 1 &&
                    extraPageResources.map((item, index) => (
                        <li
                            className={styles.categoryLi}
                            key={item.resourceGroupTitle}>
                            <a
                                className={`${styles.categoryTabItem} 
                                ${
                                    selectedResourceGroup !== null &&
                                    selectedResourceGroup.resourceGroupTitle ==
                                        item.resourceGroupTitle
                                        ? styles.categoryTabItemSelected
                                        : ""
                                }`}
                                onClick={() =>
                                    setSelectedResourceGroup(
                                        extraPageResources[index],
                                    )
                                }>
                                {item.resourceGroupTitle}
                            </a>
                        </li>
                    ))}
            </ul>

            <ul className={styles.iconPicker}>
                {selectedResourceGroup &&
                    selectedResourceGroup.content.map((c) => {
                        const extraPageInfo: number = c.id;

                        return (
                            <React.Fragment key={c.id}>
                                <li className={styles.iconPickerLi}>
                                    <div
                                        className={[
                                            styles.iconPickerItem,
                                            styles.iconPickerItemSmall,
                                            styles.iconPickerItemImageAuto,
                                        ].join(" ")}>
                                        <div className={styles.extraPage}>
                                            <div
                                                className={
                                                    styles.thumbnailAndPreview
                                                }
                                                onClick={() => {
                                                    onUpdatePreviewedExtraPage(
                                                        c.id,
                                                    );
                                                }}>
                                                <div
                                                    className={
                                                        styles.previewIconContainer
                                                    }>
                                                    <img src="/images/magnify.svg" />
                                                </div>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            c.endpoints
                                                                .thumbnail ||
                                                            "",
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <div
                                                    className={
                                                        styles.iconPickerTextWrapper
                                                    }>
                                                    <span
                                                        className={
                                                            styles.iconPickerTitle
                                                        }>
                                                        {c.title ? c.title : ""}
                                                    </span>
                                                    <br />
                                                    <span
                                                        className={
                                                            styles.iconPickerDescription
                                                        }>
                                                        {c.description}
                                                    </span>
                                                    <div
                                                        className={
                                                            styles.buttonContainer
                                                        }>
                                                        <Button
                                                            disabled={
                                                                numberOfPagesLeft <
                                                                1
                                                            }
                                                            onClick={() =>
                                                                onUpdateExtraPages(
                                                                    [
                                                                        ...addedExtraPages,
                                                                        extraPageInfo,
                                                                    ],
                                                                )
                                                            }
                                                            text={
                                                                resources[
                                                                    "ExtraPages_Add"
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </React.Fragment>
                        );
                    })}
            </ul>
        </div>
    );
};

const mapDispatchToProps = {
    ...actionCreators,
};

export default connect(null, mapDispatchToProps)(ExtraPageSelector);
